export default "__VITE_ASSET__CvasjOz___"